import React from 'react'
import { Controller } from 'react-hook-form'
import { InputText } from '@telavita-core/react-design-kit'

type FieldName = 
  'address.cep' | 
  'address.address' | 
  'address.number' | 
  'address.complement' | 
  'address.neighborhood' | 
  'address.city' | 
  'address.state'

interface AddressField {
  name: FieldName
  label: string
}

function formatCEP(value: string) {
  return value.replace(/\D/g, '')
}

const addressFieldList: AddressField[] = [
  { name: 'address.cep', label: 'CEP *'},
  { name: 'address.address', label: 'Endereço *' },
  { name: 'address.number', label: 'Número *' },
  { name: 'address.complement', label: 'Complemento (opcional)' },
  { name: 'address.neighborhood', label: 'Bairro *' },
  { name: 'address.city', label: 'Cidade *' },
  { name: 'address.state', label: 'Estado *' }
]

export const AddressInputFields = ({ control, setFocus }): JSX.Element => {
  return (
    <>
      {addressFieldList.map(({ name, label }) => (
        <Controller
          key={name}
          name={name}
          control={control}
          render={({ field, fieldState: { error }}) => {
            return(
              <InputText
                {...field}
                onChange={(e) => {
                  if (name === 'address.cep') {
                    return field.onChange(formatCEP(e.target.value))
                  }

                  return field.onChange(e)
                }}
                handleClearSearchField={() => {
                  field.onChange({ target: { value: '' }})
                  setFocus(name)
                }}
                floatingLabel={label}
                helperMessageVariant='error'
                helperMessage={error?.message}
                hasError={!!error}
                maxLength={name === 'address.cep' ? 8 : null}
              />
            )
          }}
        />
      ))}
    </>
  )
}